






































































import {Vue, Component, Provide} from 'vue-property-decorator';
import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import {Filter} from '@/utils/Filter';
import {Utils} from '@/utils/Utils';
import AssignedRoleList from '@/models/assignedrolelist';
import {API} from '@/services/api/api';
import {mapActions} from 'vuex';
import {getAssignedRoleList} from '@/services/api/roles';
@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {
    FilterMenu,
    Paginition,
  },
})
export default class AssignedPermission extends Vue {
  header = [
    {
      value: 'userName',
      name: 'Username',
      headerType: 'text',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'groupName',
      name: 'Group Name',
      headerType: 'text',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
  ];

  assignedRoleList: AssignedRoleList[] = [];

  filteredAssignedList: AssignedRoleList[] = this.assignedRoleList;

  //loader & helper variables
  showErrorToast;
  isScreenLoading = true;
  showSuccessToast;
  asdcOrder = true;
  curentSort = '';
  startingPoint = 0;
  endingPoint = 5;

  mounted() {
    this.fetchAssignedRoleList();
  }

  //fetch list from api
  async fetchAssignedRoleList() {
    try {
      let response = await getAssignedRoleList();
      if (response.data) {
        let list: AssignedRoleList[] = response.data;
        this.assignedRoleList = list;
        this.filteredAssignedList = list;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.assignedRoleList);
    this.asdcOrder = sorted;
  }

  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.endingPoint = endingPoint;
    this.startingPoint = startingPoint - 1;
  }

  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.assignedRoleList);
    this.filteredAssignedList = filteredData;
    this.resetPagination();
  }

  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.assignedRoleList);
    this.filteredAssignedList = filteredData;
    this.resetPagination();
  }

  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredAssignedList = this.assignedRoleList;
      this.resetPagination();
    }
  }

  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  editAssignedRole(roleId: number) {
    this.$router.push('/edit-assigned-role/' + roleId);
  }
}
